import { render, staticRenderFns } from "./CountChip.vue?vue&type=template&id=3bbfab3e&"
import script from "./CountChip.vue?vue&type=script&lang=js&"
export * from "./CountChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports